let config = ($provide) => {
	$provide.decorator('taOptions', ['$delegate', function(taOptions) {
		// $delegate is the taOptions we are decorating
		// here we override the default toolbars and classes specified in taOptions.
		taOptions.forceTextAngularSanitize = true; // set false to allow the textAngular-sanitize provider to be replaced
		taOptions.keyMappings = []; // allow customizable keyMappings for specialized key boards or languages
		taOptions.toolbar = [
			['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'quote'],
			['bold', 'italics', 'underline', 'ul', 'ol'],
			['justifyLeft','justifyCenter','justifyRight', 'justifyFull', 'insertLink'],
			['redo', 'undo', 'clear']
		];

		taOptions.classes = {
			focussed: 'focussed',
			toolbar: 'sb-ta-toolbar',
			toolbarGroup: 'sb-ta-button-group',
			toolbarButton: 'md-button',
			toolbarButtonActive: 'active',
			disabled: 'disabled',
			textEditor: 'form-control',
			htmlEditor: 'form-control'
		};
		return taOptions; // whatever you return will be the taOptions
	}]);
};

config.$inject = ['$provide'];

export default config;


// WEBPACK FOOTER //
// ./client/app/config/textangular-config.js